class SplideCarousel extends HTMLElement {
  constructor() {
    super();
    
    this.splideSettings = {
      waitForTransition: true,
      wheel: true,
      drag: 'free',
      wheelMinThreshold: 1,
      mediaQuery: 'min',
      releaseWheel: true,
    }
  }
  
  connectedCallback() {
    var splide = new window.Splide(this, this.splideSettings);
    splide.mount();
  }
}
customElements.define('splide-carousel', SplideCarousel);

class SubCollections extends SplideCarousel {
  constructor() {
    super();
    
    this.splideSettings = {
      ...this.splideSettings,
      autoWidth: true,
      pagination: false,
      arrows: false,
      gap: 16,
      padding: 16,
      breakpoints: {
        768: {
          padding: 20,
          gap: 20,
          arrows: true,
        },
        1300: {
          padding: 30,
          gap: 30,
        },
      }
    }
  }
}
customElements.define('sub-collections', SubCollections);